export const FETCH_CONTACTLISTS_BEGIN = "FETCH_CONTACTLISTS_BEGIN";
export const FETCH_CONTACTLISTS_SUCCESS = "FETCH_CONTACTLISTS_SUCCESS";
export const FETCH_CONTACTDETAILS_BEGIN = "FETCH_CONTACTDETAILS_BEGIN";
export const FETCH_CONTACTDETAILS_SUCCESS = "FETCH_CONTACTDETAILS_SUCCESS";
export const FETCH_CONTACTINFO_BEGIN = "FETCH_CONTACTINFO_BEGIN";
export const FETCH_CONTACTINFO_SUCCESS = "FETCH_CONTACTINFO_SUCCESS";
export const FETCH_CONTACTHEADER_SUCCESS = "FETCH_CONTACTHEADER_SUCCESS";
export const FETCH_CONTACTLISTS_FAILURE = "FETCH_CONTACTLISTS_FAILURE";

 export const FETCH_STATIC_CONTACTLIST_BEGIN='FETCH_STATIC_CONTACTLIST_BEGIN';
 export const FETCH_STATIC_CONTACTLIST_SUCCESS='FETCH_STATIC_CONTACTLIST_SUCCESS';
 export const FETCH_STATIC_CONTACTLIST_FAILURE='FETCH_STATIC_CONTACTLIST_FAILURE';


 export const FETCH_DYNAMIC_CONTACTLIST_BEGIN='FETCH_DYNAMIC_CONTACTLIST_BEGIN';
 export const FETCH_DYNAMIC_CONTACTLIST_SUCCESS='FETCH_DYNAMIC_CONTACTLIST_SUCCESS';
 export const FETCH_DYNAMIC_CONTACTLIST_FAILURE='FETCH_DYNAMIC_CONTACTLIST_FAILURE';

 export const FETCH_CONTACTLIST_BEGIN='FETCH_CONTACTLIST_BEGIN';
 export const FETCH_CONTACTLIST_SUCCESS='FETCH_CONTACTLIST_SUCCESS';
 export const FETCH_CONTACTLIST_FAILURE='FETCH_CONTACTLIST_FAILURE';
 
export const FETCH_WEBCATEGORIES_BEGIN = "FETCH_WEBCATEGORIES_BEGIN";
export const FETCH_WEBCATEGORIES_SUCCESS = "FETCH_WEBCATEGORIES_SUCCESS";
export const FETCH_WEBCATEGORIES_FAILURE = "FETCH_WEBCATEGORIES_FAILURE";

export const FETCH_WEBSTATUS_BEGIN = "FETCH_WEBSTATUS_BEGIN";
export const FETCH_WEBSTATUS_SUCCESS = "FETCH_WEBSTATUS_SUCCESS";
export const FETCH_WEBSTATUS_FAILURE = "FETCH_WEBSTATUS_FAILURE";

export const FETCH_PARENTCOMPANIES_BEGIN = "FETCH_PARENTCOMPANIES_BEGIN";
export const FETCH_PARENTCOMPANIES_SUCCESS = "FETCH_PARENTCOMPANIES_SUCCESS";
export const FETCH_PARENTCOMPANIES_FAILURE = "FETCH_PARENTCOMPANIES_FAILURE";

export const FETCH_ACCOUNTS_BEGIN = "FETCH_ACCOUNTS_BEGIN";
export const FETCH_ACCOUNTS_SUCCESS = "FETCH_ACCOUNTS_SUCCESS";
export const FETCH_ACCOUNTS_FAILURE = "FETCH_ACCOUNTSS_FAILURE";

